let resolveFn: (() => void) | null = null;

export const waitForMessageClose = (): Promise<void> => {
  return new Promise((resolve) => {
    resolveFn = resolve;
  });
};

export const handleMessageClose = () => {
  if (resolveFn) {
    resolveFn();
    resolveFn = null;
  }
};
